import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import localStorageService from 'services/storage'
import Input from 'components/Input'
import { selectCurrentUser, selectCurrentZone, selectAvailableZones, setCurrentZone } from 'store/global'
import styles from './ZoneSelect.scss'
import history from 'utils/history'

interface Zone {
  id: number
  name: string
}

interface User {
  id: number
  [key: string]: any
}

const ZoneSelect: React.FC = () => {
  const dispatch = useDispatch()

  const currentUser = useSelector(selectCurrentUser) as User
  const currentZone = useSelector(selectCurrentZone) as Zone | null
  const availableZones = useSelector(selectAvailableZones) as Zone[]

  const onZoneSelect = (zoneId: string) => {
    const nextZoneId = parseInt(zoneId)
    const nextZone = availableZones.find(({ id }) => id === nextZoneId)

    if (nextZone) {
      dispatch(setCurrentZone({ zone: nextZone }))
      localStorageService.setLastSelectedZoneForUser(currentUser, nextZone)
      history.push('/dashboard')
    }
  }

  return (
    <div className={styles.container}>
      <Input type='select' value={currentZone?.id?.toString()} onChange={onZoneSelect}>
        {availableZones.map(zone => (
          <option key={zone.id} value={zone.id}>
            {zone.name}
          </option>
        ))}
      </Input>
    </div>
  )
}

export default ZoneSelect 